import React from "react";
import "./ServiceSection.css";
import service1 from '../../imgs/services/service1.jpg';
import service2 from '../../imgs/services/service2.jpg';
import service3 from '../../imgs/services/service3.jpg';
import service4 from '../../imgs/services/engine-detail.jpg';

const servicesdata = [
  {
    title: "HEADLIGHT RESTORATION",
    subtitle: "Crystal-clear vision",
    image: service1,
  },
  {
    title: "INTERIOR CLEANING",
    subtitle: "Fresh and spotless",
    image: service2,
  },
  {
    title: "EXTERIOR WASH",
    subtitle: "Shine that lasts",
    image: service3,
  },
  {
    title: "ULTIMATE ENHANCEMENT",
    subtitle: "Interior, Exterior & Engine Detail",
    image: service4,
  },
];

function ServiceSection() {
  return (
    <section className="service-showcase">
      {servicesdata.map((service, index) => (
        <a href="/booking" key={index} className="service-link">
          <div
            className="service-box"
            style={{ backgroundImage: `url(${service.image})` }}
          >
            <div className="service-overlay">
              <h3>{service.title}</h3>
              <p>{service.subtitle}</p>
            </div>
          </div>
        </a>
      ))}
    </section>
  );
}

export default ServiceSection;
